import * as CryptoJS from 'crypto-js';

// You should store this in a secure environment configuration
const ENCRYPTION_KEY = 'J6$g9!vP2@zX#qT7fY&dL3mW^K*oR1bC';

export function encryptData(data: string): string {
  try {
    // Generate a random salt for each encryption
    const salt = CryptoJS.lib.WordArray.random(128 / 8);

    const key = CryptoJS.PBKDF2(ENCRYPTION_KEY, salt, {
      keySize: 256 / 32,
      iterations: 1000,
    });

    const encrypted = CryptoJS.AES.encrypt(data, key.toString());

    // Combine the salt and encrypted data, separated by a delimiter
    // We'll use base64 encoding to make it URL-safe
    return salt.toString() + ':' + encrypted.toString();
  } catch (error) {
    console.error('Encryption failed:', error);
    return '';
  }
}

export function decryptData(encryptedString: string): string {
  try {
    // Split the string to get salt and encrypted data
    const [salt, encrypted] = encryptedString.split(':');

    if (!salt || !encrypted) {
      throw new Error('Invalid encrypted string format');
    }

    const key = CryptoJS.PBKDF2(ENCRYPTION_KEY, salt, {
      keySize: 256 / 32,
      iterations: 1000,
    });

    const decrypted = CryptoJS.AES.decrypt(encrypted, key.toString());
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption failed:', error);
    return '';
  }
}
